export type EmailSender = {
  email: string;
  name: string;
};

export enum FromOptionValue {
  Osawa = "mitsuhiro.osawa@techreis.co.jp",
  Shimogishi = "yuta.shimogishi@techreis.co.jp",
  Okuhara = "misaki.okuhara@techreis.co.jp",
  Tanaka = "takuya.tanaka.2323@gmail.com",
  Yamaguchi = "reo.yamaguchi@techreis.co.jp",
  Arai = "hokuto.arai@techreis.co.jp",
}

export const EMAIL_SENDERS: EmailSender[] = [
  { email: FromOptionValue.Osawa, name: "大澤 光広" },
  { email: FromOptionValue.Shimogishi, name: "下岸 祐太" },
  { email: FromOptionValue.Okuhara, name: "奥原 未沙紀" },
  { email: FromOptionValue.Tanaka, name: "田中 拓哉" },
  { email: FromOptionValue.Yamaguchi, name: "山口 玲麻" },
  { email: FromOptionValue.Arai, name: "荒井 帆駆斗" },
];

export const emailToNameMap = EMAIL_SENDERS.reduce(
  (acc, sender) => {
    acc[sender.email] = sender.name;
    return acc;
  },
  {} as Record<string, string>,
);

export const fromOptions = EMAIL_SENDERS.map(sender => ({
  label: sender.name,
  value: sender.email,
}));
